module.exports = __webpack_public_path__ + "static/media/on24.58184717.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/on24.svg
// module id = qWFi
// module chunks = 89